import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { applyMiddleware, createStore } from "redux";
import { Provider } from "react-redux";
import logger from "redux-logger";
import { createEpicMiddleware } from "redux-observable";
import { rootEpic, rootReducer } from "./epics/rootFunctions";
import { __DEBUG__ } from "./lib/settings";

const epicMiddleware = createEpicMiddleware();

export const store = (() => {
  if (__DEBUG__) {
    return createStore(rootReducer, applyMiddleware(logger, epicMiddleware));
  } else {
    return createStore(rootReducer, applyMiddleware(epicMiddleware));
  }
})();

epicMiddleware.run(rootEpic);

ReactDOM.render(
  <Provider store={store}>
    <App className="app" />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
